import { render, staticRenderFns } from "./LightStripSceneCanvas.vue?vue&type=template&id=712aba04&scoped=true"
import script from "./LightStripSceneCanvas.vue?vue&type=script&lang=js"
export * from "./LightStripSceneCanvas.vue?vue&type=script&lang=js"
import style0 from "./LightStripSceneCanvas.vue?vue&type=style&index=0&id=712aba04&prod&lang=scss&scoped=true"
import style1 from "./LightStripSceneCanvas.vue?vue&type=style&index=1&id=712aba04&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_prettier@2.8.8_vue-template-compiler@2.7.16_webpack@5.101.3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "712aba04",
  null
  
)

export default component.exports